import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {DisplayBlockType} from '../../views/timeline/timeline.component';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  activeBlockId$ = new Subject<string>();
  blocks$ = new BehaviorSubject<DisplayBlockType[]>([]);

  setBlocks(blocks: DisplayBlockType[]): void {
    const filtered = this.filterFutureDate(blocks);

    this.blocks$.next(filtered);
  }

  getBlocks(): Subject<DisplayBlockType[]> {
    return this.blocks$;
  }

  setActiveBlockId(id: string): void {
    this.activeBlockId$.next(id);
  }

  getActiveBlockId(): Subject<string> {
    return this.activeBlockId$;
  }

  filterFutureDate(blocks: DisplayBlockType[]): DisplayBlockType[] {
    const blocksById = blocks.reduce((blockMap, block) => {
      const existingBlock = blockMap.get(block.id);

      if (!existingBlock) {
        blockMap.set(block.id, block);

        return blockMap;
      }

      const currentBlockDate = moment(block.beginDate, 'DD-MM-YYYY');
      const existingBlockDate = moment(existingBlock.beginDate, 'DD-MM-YYYY');
      const now = moment();

      const currentIsFuture = currentBlockDate.isSameOrAfter(now, 'day');
      const existingIsFuture = existingBlockDate.isSameOrAfter(now, 'day');

      if (currentIsFuture && !existingIsFuture) {
        blockMap.set(block.id, block);
      }

      if (
        currentIsFuture &&
        existingIsFuture &&
        currentBlockDate.diff(now) < existingBlockDate.diff(now)
      ) {
        blockMap.set(block.id, block);
      }

      if (
        !currentIsFuture &&
        !existingIsFuture &&
        now.diff(currentBlockDate) < now.diff(existingBlockDate)
      ) {
        blockMap.set(block.id, block);
      }

      return blockMap;
    }, new Map<string, DisplayBlockType>());

    return Array.from(blocksById.values());
  }

  filterClosestDate(blocks: DisplayBlockType[]): DisplayBlockType[] {
    const blocksById = blocks.reduce((blockMap, block) => {
      const existingBlock = blockMap.get(block.id);

      if (!existingBlock) {
        blockMap.set(block.id, block);

        return blockMap;
      }

      const currentBlockDate = moment(block.beginDate, 'DD-MM-YYYY');
      const existingBlockDate = moment(existingBlock.beginDate, 'DD-MM-YYYY');
      const now = moment();

      const currentDiff = Math.abs(now.diff(currentBlockDate));
      const existingDiff = Math.abs(now.diff(existingBlockDate));

      if (currentDiff < existingDiff) {
        blockMap.set(block.id, block);
      }

      return blockMap;
    }, new Map<string, DisplayBlockType>());

    return Array.from(blocksById.values());
  }
}
